{
  "pageTitles": {
    "bilan": "Bilan"
  },
  "serverErrors": {
    "401": "Les informations fournies ne sont pas valable",
    "404": "La ressource demandée n'a pas été trouvé"
  },
  "labelText": {
    "error": "Une erreur est survenue, veuillez ré-essayer",
    "download": "Télécharger",
    "needHelp": "Besoin d'aide ?"
  },
  "fieldErrors": {
    "fieldRequired": "Ce champ est requis",
    "minSize": "Le champs doit contenir au moins {minSize} caractères"
  },
  "bilan": {
    "bilanTitle": "Accès aux bilans",
    "bilanText": "Afin de récupérer le bilan,",
    "bilanText2": "saisissez le code challenge fourni par l'équipe déposant le patient",
    "bilanBtn": "Acceder",
    "bilanCode": "Code challenge*",
    "bilanName": "Votre nom*",
    "zipcode": "Code postal du patient",
    "bilanPatientName": "Nom du patient*",
    "birthDate": "Date de naissance du patient",
    "birthZipcode": "Code postal du lieu de naissance du patient",
    "bilanInaccessible": "Si le bilan n'est pas accessible, vous pouvez cliquer sur le bouton pour le télécharger",
    "bilanNoId": "Retirer les pièces d'identité du bilan"
  }
}
